import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShieldCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8 1.5 13.5 4 12.3 11.8 8 14.2 3.7 11.8 2.5 4 z",
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.2
	}), /* @__PURE__ */ _jsx("path", {
		d: "m5.5 8 2 2 3.5-4",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.2
	})]
});
export default SvgShieldCheck;
